import { ISobCompetitor } from 'partner360/models/ISobCompetitor'
import { ISobCompetitorsGroup } from 'partner360/models/ISobCompetitorsGroup'

import { mapSobCompetitorToSobCompetitorDependOnSettings } from './mapSobCompetitorToSobCompetitorDependOnSettings'

interface IGetGroupedSobCompetitors {
  data: ISobCompetitor[]
  getValue: (el: ISobCompetitor, fields: string[]) => number
  getPercent: (el: ISobCompetitor, fields: string[]) => number
}
export const getGroupedSobCompetitors = ({
  data,
  getValue,
  getPercent,
}: IGetGroupedSobCompetitors): ISobCompetitorsGroup[] => {
  return data.reduce((acc: ISobCompetitorsGroup[], el: ISobCompetitor) => {
    const { Name, EntryId, ParentId, NameKey, IsExpanded, SortOrder } = el

    const groupIndex = acc.findIndex((group) => group.Name === Name)
    const mappedItem = mapSobCompetitorToSobCompetitorDependOnSettings({ el, getValue, getPercent })
    if (groupIndex !== -1) {
      const updatedGroup = {
        ...acc[groupIndex],
        Items: [...acc[groupIndex].Items, mappedItem],
      }

      return [...acc.slice(0, groupIndex), updatedGroup, ...acc.slice(groupIndex + 1)]
    } else {
      const newGroup: ISobCompetitorsGroup = {
        EntryId,
        Name,
        NameKey,
        ParentId,
        SortOrder,
        IsExpanded: IsExpanded || 0,
        Items: [mappedItem],
      }

      return [...acc, newGroup]
    }
  }, [])
}
